<template>
  <div
    v-click-outside="onClickOutside"
    class="filter-select-box"
  >
    <el-button
      class="calendar word-btn"
      :class="{selected: isPresentFilterSelected}"
      @click="handleClickButton"
    >
      필터
    </el-button>

    <transition
      name="el-zoom-in-top"
    >
      <div
        v-show="isPannelVisible"
        class="select-box__pannel"
      >
        <div
          v-if="!courses || courses.length === 0"
          class="select-box__pannel__guide"
        >
          개설된 수업이 없습니다.
        </div>
        <ul
          v-else
          class="select-box-dropdown__list"
        >
          <li
            v-for="(item, index) in courses"
            :key="index"
            class="select-box-dropdown__item"
            :class="presentOptionClass(item.id)"
            @click="handleClickDropdownItem(item.id)"
          >
            <span
              style="float: left;"
              class="filter-select-box__course-name"
            >
              <span style="margin-right: 10px;">
                {{ presentCourseTime(item) }}
              </span>
              <span>{{ item.parent_course.name }}</span>
            </span>
          </li>
        </ul>
        <section
          v-if="courses && courses.length > 0"
          id="filter-buttons"
        >
          <button 
            :disabled="isLoading"
            @click.prevent="hadleClickAndSendAction('initialized')"
          >
            초기화
          </button>
          <button
            :disabled="isLoading"
            @click.prevent="hadleClickAndSendAction('search')"
          >
            필터 적용
          </button>
        </section>
        <section
          v-if="isLoading && courses && courses.length > 0"
          id="loading-screen-container"
        >
          <i
            class="el-icon-loading"
          />
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import dateFns from 'date-fns';

export default {
  name: 'CourseFilterSelect',
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    courses: {
      required: true,
      type: Array
    },
    value: {
      required: true
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isPannelVisible: false,
      selectedCourses: [],
      isPresentFilterSelected: false
    };
  },
  watch: {
    isPannelVisible() {
      // 모달이 열리고 닫힐 때 마다, 실제 업데이트 되어있는 수업들로 필터링을 업데이트 합니다.
      this.$emit('input', this.$localStore.getValue('filteringCourses') || []);
    },
    isLoading(result) {
      // 로딩요청을 보낼 때의 수업들로 isPresentFilterSelected 를 업데이트 합니다.
      if (result) {
        const result = this.hasSelectedCourse();
        this.isPresentFilterSelected = result;
      }
    },
    courses: {
      // 요일이 변경될 때마다 입력받은 수업들로 isPresentFilterSelected 를 업데이트 합니다.
      immediate: true,
      handler: function(data) {
        const result = this.hasSelectedCourse(data);
        this.isPresentFilterSelected = result;
      }
    }
  },
  methods: {
    handleClickButton() {
      this.isPannelVisible = !this.isPannelVisible;
    },
    presentOptionClass(value) {
      return {
        selected: this.value.indexOf(value) > -1
      };
    },
    presentCourseTime(course) {
      let endTime = dateFns.addMinutes(course.start, course.duration);
      return `${dateFns.format(course.start, 'HH:mm')} - ${dateFns.format(
        endTime,
        'HH:mm'
      )}`;
    },
    onClickOutside() {
      this.isPannelVisible = false;
    },
    handleClickDropdownItem(option) {
      const value = this.value.slice();

      let optionIndex = value.indexOf(option);

      if (optionIndex > -1) {
        value.splice(optionIndex, 1);
      } else {
        value.push(option);
      }

      this.selectedCourses = [...value];

      this.$emit('input', value);
    },
    hadleClickAndSendAction(action) {
      // 초기화 액션때는 선택된 value 중 금일 수업에 관련된 것들은 모두 지우고 업데이트한다.
      if (action === 'initialized') {
        this.selectedCourses = this.value.filter(
          value => !this.courses.map(value => value.id).includes(value)
        );
        this.$emit('input', this.selectedCourses);
      }
      const payload = {
        type: action,
        data: this.selectedCourses
      };

      this.$emit('click', payload);
    },
    // 파라미터로 받은 수업데이터를 통해 현재 선택된 수업내역들이 있는지 체크합니다.
    hasSelectedCourse(coursesData) {
      const courses = coursesData || this.courses;
      const selectedValue = this.value
        .map(value => {
          return courses.find(course => course.id == value);
        })
        .filter(value => value);
      return selectedValue.length > 0;
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/components/select-box.scss';

.filter-select-box {
  margin-left: 10px;
  display: inline-block;
  position: relative;

  .select-box-dropdown__list {
    margin: 0;
  }

  .select-box__pannel {
    right: 0;
    width: 260px;
  }
}

.filter-select-box__course-name {
  display: inline-block;
  width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.select-box__pannel__guide {
  height: 34px;
  line-height: 22px;
  padding: 6px 0;
}

.word-btn {
  &.selected {
    &:before {
      content: '';
      width: 9px;
      height: 9px;
      border-radius: 9px;
      position: absolute;
      right: -3px;
      top: -3px;
      box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
      background-color: #4a4a4a;
    }
  }
}

#filter-buttons {
  box-sizing: border-box;
  width: 100%;
  background-color: #fff;
  border-radius: 0 0 4px 4px;
  display: flex;
  border-top: solid 1px #d3d3d3;
  box-shadow: 0 5px 6px 0 rgba(180, 180, 180, 0.5);

  button {
    border: none;
    font-family: NotoSansCJKkr, sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -0.8px;
    background-color: #fff;
    margin: 13px auto;

    &:first-child {
      margin-left: 10px;
      color: #d3d3d3;
    }

    &:first-child:disabled {
      cursor: not-allowed;
    }

    &:last-child {
      margin-right: 10px;
      color: #4a4a4a;
    }

    &:last-child:disabled {
      color: #d3d3d3;
      cursor: not-allowed;
    }
  }
}

#loading-screen-container {
  position: absolute;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(2px);
  display: flex;
  top: 0;
  left: 0;
  i {
    margin: auto;
  }
}
</style>
